/* eslint-disable import/prefer-default-export */
/* eslint-disable no-use-before-define */
import { isEmpty, get } from 'lodash';

const conditionToString = condition => {
  const leftOperand = condition.field.name;

  let operator;
  let rightOperand;

  if ('values' in condition) {
    if (condition.invert_operator) {
      operator = '!=';
    } else {
      operator = '=';
    }

    rightOperand = condition.values
      .reduce((acc, item) => [...acc, get(item, 'name', item)], [])
      .join(', ');
  } else {
    if (condition.invert_operator) {
      operator = 'Is-Not';
    } else {
      operator = 'Is';
    }

    rightOperand = condition.statuses.join(', ');
  }
  return [leftOperand, operator, rightOperand].join(' ');
};

export const conditionGroupToString = conditionGroup => {
  if (isEmpty(conditionGroup)) {
    return '';
  }

  const text = [];
  const isAnd = conditionGroup.logical_operator === 'AND';

  for (const condition of conditionGroup.conditions) {
    let conditionString = conditionNodeToString(condition);

    // Higher priority operators are higher in the AST
    // If otherwise, the user has provided the low priority Op in a parenthesis
    if (
      isAnd &&
      condition['@type'] === 'group' &&
      condition.logical_operator === 'OR'
    ) {
      conditionString = `(${conditionString})`;
    }

    text.push(conditionString);
  }

  return text.join(` ${conditionGroup.logical_operator} `);
};

const conditionNodeToString = conditionNode => {
  if (conditionNode['@type'] === 'group') {
    return conditionGroupToString(conditionNode);
  }
  return conditionToString(conditionNode);
};
